const ADS_ID = "AW-18527453117";
const VENDOR_CONVERSION = "AW-18527453117/3jDFCP7u3qMdEL3_yYJF";

export function loadGoogleTag() {
  if (window.__ecGtagLoaded) return;
  window.__ecGtagLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  const granted = localStorage.getItem("ec_cookie_consent") === "accepted" ? "granted" : "denied";
  window.gtag("consent", "default", { ad_storage: granted, ad_user_data: granted, ad_personalization: granted, analytics_storage: granted });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);
}

export function updateAdsConsent(accepted) {
  if (!window.gtag) return;
  const v = accepted ? "granted" : "denied";
  window.gtag("consent", "update", { ad_storage: v, ad_user_data: v, ad_personalization: v, analytics_storage: v });
}

export function trackVendorConversion() {
  if (window.gtag) window.gtag("event", "conversion", { send_to: VENDOR_CONVERSION });
}
